if (!customElements.get("brand-list")) {
  class BrandList extends HTMLElement {
    constructor() {
      super();
      this.onLetterClick = this.onLetterClick.bind(this);
    }

    connectedCallback() {
      if (this._initialized) return;

      this._initialized = true;
      this.initElements();
      this.bindEvents();
      this.syncLetterState();
      this.applyFilters();
    }

    disconnectedCallback() {
      this.unbindEvents();
      this._initialized = false;
    }

    initElements() {
      this.groups = [...this.querySelectorAll("[data-group]")];
      this.letterButtons = [...this.querySelectorAll("[data-letter]")];
      this.activeLetter = this.letterButtons[0]?.dataset.letter || "ALL";
    }

    bindEvents() {
      this.letterButtons.forEach((button) =>
        button.addEventListener("click", this.onLetterClick),
      );
    }

    unbindEvents() {
      this.letterButtons.forEach((button) =>
        button.removeEventListener("click", this.onLetterClick),
      );
    }

    onLetterClick(event) {
      const button = event.currentTarget;

      if (button.getAttribute("aria-disabled") === "true") return;

      this.activeLetter = button.dataset.letter || "ALL";
      this.syncLetterState();
      this.applyFilters();
      this.scrollToLetter(this.activeLetter);
    }

    scrollToLetter(letter) {
      if (letter === "ALL") {
        const top = this.querySelector("#brand-list-top");
        if (top) top.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      const group = this.querySelector(`[data-group="${letter}"]`);
      if (group) group.scrollIntoView({ behavior: "smooth", block: "start" });
    }

    syncLetterState() {
      this.letterButtons.forEach((button) => {
        const isActive = button.dataset.letter === this.activeLetter;
        button.classList.toggle("font-semibold", isActive);
        button.classList.toggle("font-medium", !isActive);

        if (isActive) {
          button.style.color = "#088ae4";
        } else {
          button.style.removeProperty("color");
        }
      });
    }

    applyFilters() {
      const activeLetter = this.activeLetter || "ALL";

      this.groups.forEach((group) => {
        const groupLetter = group.dataset.group || "";
        const shouldShow =
          activeLetter === "ALL" || activeLetter === groupLetter;

        group.classList.toggle("hidden", !shouldShow);
      });
    }
  }

  customElements.define("brand-list", BrandList);
}
